import { Fragment } from 'react'
import parse from 'html-react-parser'
import Head from 'next/head'

import { WPPageData } from '@/types'

type MetaProps = {
  pageData: WPPageData
}

const Meta = ({ pageData }: MetaProps) => {
  const robotsContent = [
    pageData?.meta_robots?.is_robots_noindex ? 'noindex' : 'index',
    pageData?.meta_robots?.is_robots_nofollow ? 'nofollow' : 'follow'
  ]
    .filter(Boolean)
    .join(', ')

  // Opzione 1: Avvolgere il risultato di parse in un Fragment con una key
  return (
    <Head>
      {pageData?.yoast_head ? (
        <Fragment key="yoast-head">{parse(pageData.yoast_head)}</Fragment>
      ) : null}
      {robotsContent ? <meta name="robots" content={robotsContent} /> : null}
    </Head>
  )
}

export default Meta
